<script setup lang="ts">
  import type { ToastOptions } from 'vue3-toastify'
  import { sanitizeBasicHtml } from '~/utils/htmlSafety'

  const props = defineProps<{
    closeToast: (e?: MouseEvent) => void
    toastProps: ToastOptions<{
      message: string
      details: string
      action?: {
        label: string
        click: () => Promise<void>
      }
    }>
  }>()

  // Details can contain API error text, which may repeat user input.
  const safeDetails = computed(() => sanitizeBasicHtml(props.toastProps.data?.details))
</script>

<template>
  <div
    class="relative z-[999] flex w-full flex-row items-stretch !pointer-events-auto"
    data-testid="toast-action-layout"
  >
    <div class="flex min-w-0 flex-1 items-center px-6 py-5 text-left">
      <div class="whitespace-normal first-letter:uppercase">
        {{ props.toastProps.data?.message }}
        <!-- eslint-disable vue/no-v-html -- sanitized -->
        <div
          v-if="safeDetails"
          class="first-letter:uppercase italic text-neutral-100"
          v-html="safeDetails"
        />
        <!-- eslint-enable vue/no-v-html -->
      </div>
    </div>
    <div
      class="flex shrink-0 flex-col items-stretch divide-y border-l"
      :class="props.toastProps.data?.action ? 'w-40' : 'w-24'"
      data-testid="toast-action-rail"
    >
      <button
        v-if="props.toastProps.data?.action"
        type="button"
        class="min-h-9 flex-1 px-4 py-2 text-sm leading-tight whitespace-normal first-letter:uppercase hover:bg-gray-500/20"
        @click="
          async () => {
            props.toastProps.data?.action?.click()
            props.closeToast()
          }
        "
      >
        {{ props.toastProps.data.action?.label ?? 'Action' }}
      </button>
      <button
        type="button"
        class="z-[999] min-h-9 flex-1 cursor-pointer px-4 py-2 text-sm leading-tight whitespace-normal hover:bg-gray-500/20"
        @click="props.closeToast"
      >
        Dismiss
      </button>
    </div>
  </div>
</template>

<style scoped></style>
